import { __rest } from "tslib";
import React from 'react';
import cn from 'classnames';
import { Transition } from 'react-transition-group';
import styles from './FadeInOut.module.scss';
const DELAY = 300;
const FadeInOut = (_a) => {
    var { children, className, isDelayed, isVisible } = _a, props = __rest(_a, ["children", "className", "isDelayed", "isVisible"]);
    const enterDelay = isDelayed ? DELAY : 0;
    return (React.createElement(Transition, { timeout: { enter: enterDelay, exit: DELAY }, in: !!isVisible, unmountOnExit: true }, (transitionState) => (React.createElement("div", Object.assign({ className: cn(styles.container, styles[transitionState], className) }, props), children))));
};
export default FadeInOut;
//# sourceMappingURL=FadeInOut.js.map